import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import Stack from '@mui/material/Stack';
import CustomTextField from '../base/CustomTextField';
import {
	IDENTIFIER_TYPES,
	NEW_NON_EMPLOYEE_KEYS,
} from 'pages/NewNonEmployee/_const';
import DriversLicenseState from './DriversLicenseState';
import Universities from './Universities';
import PartnerType from './PartnerType';
import SocialSecurityNumber from './SocialSecurityNumber';

/**
 * Prompt user for input: identifier number
 * The display is dependent upon the type selected in the `IdentifierType` component
 * @param {any} props properties to be passed to the textbox
 * @returns {ReactElement} textbox prompting for identifier
 */
const IdentifierNumber = props => {
	const { values } = useFormikContext();
	const type = values[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_TYPE];
	let Field = null;
	const commonProps = {
		required: true,
		name: NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_NUMBER,
		...props,
	};

	switch (type) {
		case IDENTIFIER_TYPES.SOCIAL_SECURITY_NUMBER:
			Field = <SocialSecurityNumber {...commonProps} />;
			break;
		case IDENTIFIER_TYPES.VISA:
			Field = <CustomTextField label='Visa Number' {...commonProps} />;
			break;
		case IDENTIFIER_TYPES.PASSPORT:
			Field = (
				<CustomTextField label='Passport Number' {...commonProps} />
			);
			break;
		case IDENTIFIER_TYPES.DRIVERS_LICENSE:
			Field = (
				<Stack direction={{ sm: 'column', md: 'row' }} spacing={2}>
					<DriversLicenseState
						label="Driver's License State"
						name={NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_SPECIFIER}
					/>
					<CustomTextField
						label="Driver's License Number"
						{...commonProps}
					/>
				</Stack>
			);
			break;
		case IDENTIFIER_TYPES.EU_IDENTIFIER:
			Field = (
				<CustomTextField
					label='EU Identifier Number'
					{...commonProps}
				/>
			);
			break;
		case IDENTIFIER_TYPES.MICROSOFT_ID:
			Field = (
				<CustomTextField label='Microsoft ID Number' {...commonProps} />
			);
			break;
		case IDENTIFIER_TYPES.UNIVERSITY_ID:
			Field = (
				<Stack direction={{ sm: 'column', md: 'row' }} spacing={2}>
					<Universities
						label='University'
						name={NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_SPECIFIER}
					/>
					<CustomTextField
						label='University Student ID Number'
						{...commonProps}
					/>
				</Stack>
			);
			break;
		case IDENTIFIER_TYPES.PARTNER_ID:
			Field = (
				<Stack direction={{ sm: 'column', md: 'row' }} spacing={2}>
					<PartnerType
						label='Partner'
						name={NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_SPECIFIER}
					/>
					<CustomTextField
						label='Partner ID Number'
						{...commonProps}
					/>
				</Stack>
			);
			break;
		case IDENTIFIER_TYPES.AADHAR_NUMBER:
			Field = <CustomTextField label='Aadhaar Number' {...commonProps} />;
			break;

		default:
			break;
	}

	return Field;
};

export default IdentifierNumber;
